import { makeAutoObservable } from 'mobx';
import { validateGreenToRedCandles } from './validateGreenToRedCandles';

export class GreenToRedCandlesData {
  candleDuration = 1;
  inRightDirectionPct = 0;
  retracePct = 50;
  minCandleHeight = 0.1;
  timeUnit = 'MINUTES';

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach((field) => {
        if (field === 'inRightDirectionPct' || field === 'retracePct') {
          this[field] = Number(initialData[field]) * 100;
        }
        this[field] = initialData[field];
      });
    }
  }

  //common methods
  resetToDefaults = () => {
    this.candleDuration = 1;
    this.inRightDirectionPct = 0;
    this.retracePct = 40;
    this.minCandleHeight = 0.1;
    this.timeUnit = 'MINUTES';
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = () => {
    const data = {
      candleDuration: this.candleDuration,
      inRightDirectionPct: this.inRightDirectionPct,
      retracePct: this.retracePct,
      minCandleHeight: this.minCandleHeight,
      timeUnit: this.timeUnit,
    };
    const result = validateGreenToRedCandles(data);
    return result;
  };
  returnJson = () => {
    return {
      candleDuration: this.candleDuration,
      inRightDirectionPct: Number(this.inRightDirectionPct) / 100,
      retracePct: Number(this.retracePct) / 100,
      minCandleHeight: this.minCandleHeight,
      timeUnit: this.timeUnit,
    };
  };

  //specific methods
  setCandleDuration = (number) => {
    this.candleDuration = number;
  };
  setInRightDirectionPct = (number) => {
    this.inRightDirectionPct = number;
  };
  setRetracePct = (number) => {
    this.retracePct = number;
  };
  setMinCandleHeight = (number) => {
    this.minCandleHeight = number;
  };
  setTimeUnit = (string) => {
    this.timeUnit = string;
  };
}
